
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequirea579"];
var parcelRegister = parcelRequire.register;
parcelRegister("5pFC1", function(module, exports) {

$parcel$export(module.exports, "getEmbeddingAccepted", function () { return $3f0f90df9c0e6fc5$export$cfa55ad00aed01e2; });
$parcel$export(module.exports, "checkCMInit", function () { return $3f0f90df9c0e6fc5$export$5e1809064fcc045e; });
$parcel$export(module.exports, "init", function () { return $3f0f90df9c0e6fc5$export$2cd8252107eb640b; });
function $3f0f90df9c0e6fc5$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $3f0f90df9c0e6fc5$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $3f0f90df9c0e6fc5$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $3f0f90df9c0e6fc5$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
// =============================================================================
// CCM19 module
// =============================================================================
var $3f0f90df9c0e6fc5$var$updateEvent = new CustomEvent("asuc-updated");
var $3f0f90df9c0e6fc5$var$data = {
    v: null,
    acceptedEmbeddings: []
};
var $3f0f90df9c0e6fc5$var$domReady = ()=>{
    return new Promise((resolve)=>{
        if (document.readyState === "complete" || document.readyState === "interactive") resolve();
        else document.addEventListener("DOMContentLoaded", ()=>{
            resolve();
        }, {
            once: true
        });
    });
};
var $3f0f90df9c0e6fc5$var$checkCMVersion = ()=>{
    if (typeof CCM !== "undefined") $3f0f90df9c0e6fc5$var$data.v = 1;
};
var $3f0f90df9c0e6fc5$export$68b95bd7d4d803d7 = /*#__PURE__*/ function() {
    var _ref = $3f0f90df9c0e6fc5$var$_asyncToGenerator(function*() {
        if ($3f0f90df9c0e6fc5$var$data.v === 1) $3f0f90df9c0e6fc5$var$data.acceptedEmbeddings = CCM.acceptedEmbeddings;
    });
    return function getCMData() {
        return _ref.apply(this, arguments);
    };
}();
var $3f0f90df9c0e6fc5$export$cfa55ad00aed01e2 = (name)=>{
    if ($3f0f90df9c0e6fc5$var$data.v === 1) // Return true if the embedding with the given id is accepted
    return Array.isArray($3f0f90df9c0e6fc5$var$data.acceptedEmbeddings) && $3f0f90df9c0e6fc5$var$data.acceptedEmbeddings.some((e)=>e.name === name);
};
var $3f0f90df9c0e6fc5$export$5e1809064fcc045e = /*#__PURE__*/ function() {
    var _ref2 = $3f0f90df9c0e6fc5$var$_asyncToGenerator(function*() {
        if ($3f0f90df9c0e6fc5$var$data.v === 1) return CCM.consent;
        return false;
    });
    return function checkCMInit() {
        return _ref2.apply(this, arguments);
    };
}();
var $3f0f90df9c0e6fc5$export$1e38b389321b17b = /*#__PURE__*/ function() {
    var _ref3 = $3f0f90df9c0e6fc5$var$_asyncToGenerator(function*(id) {
        $3f0f90df9c0e6fc5$var$checkCMVersion();
        if ($3f0f90df9c0e6fc5$var$data.v === 1) CCM.openControlPanel();
    });
    return function acceptCMService(_x) {
        return _ref3.apply(this, arguments);
    };
}();
var $3f0f90df9c0e6fc5$export$2cd8252107eb640b = ()=>{
    $3f0f90df9c0e6fc5$var$checkCMVersion();
    $3f0f90df9c0e6fc5$export$68b95bd7d4d803d7();
    var acceptBtns = document.querySelectorAll(".asuc-accept");
    acceptBtns.forEach((btn)=>{
        btn.addEventListener("click", /*#__PURE__*/ $3f0f90df9c0e6fc5$var$_asyncToGenerator(function*() {
            if ($3f0f90df9c0e6fc5$var$data.v === 1) CCM.openControlPanel();
        }));
    });
    // get latest data on events
    var promise = $3f0f90df9c0e6fc5$var$domReady();
    promise.then(()=>{
        document.dispatchEvent($3f0f90df9c0e6fc5$var$updateEvent);
        if ($3f0f90df9c0e6fc5$var$data.v === 1) {
            window.addEventListener("ccm19WidgetLoaded", function(e) {
                $3f0f90df9c0e6fc5$export$68b95bd7d4d803d7();
                document.dispatchEvent($3f0f90df9c0e6fc5$var$updateEvent);
            });
            window.addEventListener("ccm19EmbeddingAccepted", function(e) {
                $3f0f90df9c0e6fc5$export$68b95bd7d4d803d7();
                document.dispatchEvent($3f0f90df9c0e6fc5$var$updateEvent);
            });
            window.addEventListener("ccm19WidgetClosed", function(e) {
                $3f0f90df9c0e6fc5$export$68b95bd7d4d803d7();
                document.dispatchEvent($3f0f90df9c0e6fc5$var$updateEvent);
            });
        }
    });
};

});


//# sourceMappingURL=ccm19.module.c3dbcd50.js.map
